import { useEffect, useState } from 'react';
import { Smartphone, X } from 'lucide-react';
import { Button } from './ui/button';
import { canPromptInstall, isIOS, isStandalone, promptInstall, subscribeInstall } from '../lib/pwa';

const DISMISS_KEY = 'installHintDismissed';

const readDismissed = () => {
  try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
};

// Einmaliger Hinweis auf Handy/Tablet: Android bietet die Installation direkt an,
// iOS nur über „Teilen → Zum Home-Bildschirm“
export const InstallHint = () => {
  const [dismissed, setDismissed] = useState(readDismissed);
  const [canPrompt, setCanPrompt] = useState(canPromptInstall);

  useEffect(() => subscribeInstall(() => setCanPrompt(canPromptInstall())), []);

  const ios = isIOS();
  if (dismissed || isStandalone() || !(canPrompt || ios)) return null;

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* ignorieren */ }
  };

  const install = async () => {
    if (await promptInstall()) dismiss();
  };

  return (
    <div
      className="pointer-events-auto flex items-center gap-3 rounded-lg border border-lunefire-red/30 bg-card/95 backdrop-blur px-3 py-2 shadow-lg font-body md:max-w-sm"
      data-testid="install-hint"
    >
      <Smartphone className="w-5 h-5 text-lunefire-red shrink-0" />
      <p className="flex-1 text-xs leading-snug">
        {canPrompt
          ? 'Lünefire FPS als App auf dem Startbildschirm installieren.'
          : <>Als App nutzen: auf <strong>Teilen</strong> tippen, dann <strong>„Zum Home-Bildschirm“</strong>.</>}
      </p>
      {canPrompt && (
        <Button size="sm" className="h-9 bg-lunefire-red hover:bg-lunefire-red/90 text-white" onClick={install}>
          Installieren
        </Button>
      )}
      <Button size="icon" variant="ghost" className="h-9 w-9 shrink-0" onClick={dismiss} aria-label="Hinweis schließen">
        <X className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default InstallHint;
